import styled, { css } from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';

import { useAdRefresh, useStickyPosition } from '../../hooks';

import { DisplayAdProfileHalfpageBig } from './halfpage-sticky-ad-big';

const AD_INITIAL_TOP = 290;
const AD_FIXED_TOP = 85;
const AD_MAX_HEIGHT = 600;
const STICKY_THRESHOLD = 287;

const OverflowContainer = styled.div`
  overflow-x: clip;
`;

const Wrapper = styled.div`
  width: 1030px;
  margin: 0 auto;
  position: relative;
`;

const AdContainer = styled.div<{ $isFixed: boolean; $topPosition: number }>`
  position: absolute;
  min-width: 120px;
  max-width: 300px;
  min-height: 250px;
  max-height: ${AD_MAX_HEIGHT}px;
  left: 100%;
  top: ${({ $topPosition }) => $topPosition}px;
  z-index: 1;

  ${({ $isFixed }) =>
    $isFixed &&
    css`
      position: fixed;
      left: auto;
      top: ${AD_FIXED_TOP}px;
      margin-left: 1030px;
    `}
`;

export const DisplayAdProfileHalfpageSlotBig: React.FC = () => {
  const isBigScreen = useMatchMedia('(min-width: 1700px)');
  const {
    isFixed,
    stickyElementRef: adContainerRef,
    topPosition,
    wrapperRef,
  } = useStickyPosition({
    fixedTopPosition: AD_FIXED_TOP,
    initialTopPosition: AD_INITIAL_TOP,
    maxHeight: AD_MAX_HEIGHT,
    stickyThreshold: STICKY_THRESHOLD,
  });

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen: !isBigScreen,
    slots: {
      mobile: '',
      desktop: 'halfpage',
    },
  });

  if (!isBigScreen) {
    return null;
  }

  return (
    <OverflowContainer>
      <Wrapper ref={wrapperRef}>
        <NoSSR>
          <AdContainer
            ref={adContainerRef}
            $isFixed={isFixed}
            $topPosition={topPosition}
          >
            <DisplayAdProfileHalfpageBig refresh={refreshDesktop} />
          </AdContainer>
        </NoSSR>
      </Wrapper>
    </OverflowContainer>
  );
};
